import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TableCell,
  TextField,
  Typography,
  createTheme,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

import { styled } from "@mui/material"
import React from "react"

export const CustomCell = styled(TableCell)`
  height: 45px;
  position: sticky;
  left: 0;
  background-color: #f7f7f7;
`

export const customTheme = createTheme({
  typography: {
    fontFamily: ["Poppins"].join(","),
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderCollapse: "collapse",
          boxShadow: "none",
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: "unset",
          boxShadow: "none",
          overflowX: "initial",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: "0px",
          border: "none",
          outline: "none",
          "&:focus": {
            outline: "none",
          },
        },
      },
    },
  },
})

export const tableHeadStyles = {
  width: "217px",
  borderRight: "none",
  boxShadow: "0px 3px 6px #00000029",
  height: "32px",
  fontSize: "13px",
  padding: 0,
  color: "#000",
  fontWeight: "600",
  zIndex: "2",
}

type formDialogProps = {
  open: boolean
  closeHandler: () => void
  createHandler: any
}

export type formType = {
  label: string
  type?: "text" | "number"
  value: number | string
  placeHolder: string
  required?: boolean
  componentType: 1 | 2
  props?: any
  options?: string[]
  error: boolean
  validation?: {
    min: number
    max: number
  }
  errorMessage?: string
}
const formFields: formType[] = [
  {
    label: "Metric Name",
    type: "text",
    placeHolder: "Metric 101",
    componentType: 1,
    value: "",
    required: true,
    props: {
      autoFocus: true,
    },
    error: false,
  },
  {
    label: "Metric Hover text",
    type: "text",
    value: "",
    placeHolder: "New metric 101",
    componentType: 1,
    required: true,
    error: false,
  },
  {
    label: "Goal Type",
    placeHolder: "Goal Type",
    componentType: 2,
    required: true,
    value: "N/A",
    options: ["$", "%", "#", "N/A"],
    error: false,
  },
  {
    label: "Metric Benchmark",
    type: "number",
    placeHolder: "0 - 99999",
    value: 0,
    componentType: 1,
    error: false,
    validation: {
      min: 0,
      max: 99999,
    },
  },
  {
    label: "Metric Highlighting Rule",
    type: "text",
    placeHolder: "Metric Highlighting Rule",
    componentType: 1,
    value: "",
    error: false,
  },
  {
    label: "Metric Direction",
    placeHolder: "Metric Highlighting Rule",
    componentType: 2,
    options: ["Up", "Down", "Between", "Range", "N/A"],
    value: "N/A",
    error: false,
  },
  {
    label: "Metric Trend Duration",
    type: "number",
    placeHolder: "0 - 999",
    componentType: 1,
    value: 0,
    error: false,
    validation: {
      min: 0,
      max: 999,
    },
  },
  {
    label: "Precision",
    type: "number",
    placeHolder: "Precision Value",
    componentType: 1,
    value: 0,
    error: false,
    validation: {
      min: 0,
      max: 9,
    },
  },
]

export const FormDialog = (props: formDialogProps) => {
  const { open, closeHandler, createHandler } = props
  const [formState, setformState] = React.useState(
    JSON.parse(JSON.stringify(formFields)),
  )
  const [loading, setLoading] = React.useState<boolean>(false)

  const submitHandler = () => {
    let newFormState: formType[] = [...formState]
    let failed = false
    formState.forEach((field: formType) => {
      if (field.required && !field.value) {
        field.error = true
        field.errorMessage = "Field is required"
        failed = true
      } else {
        field.error = false
      }
    })
    if (failed) {
      return setformState(newFormState)
    }
    newFormState.forEach((field) => {
      if (field.validation) {
        const fieldValue = field.value as number
        if (
          fieldValue < field.validation.min ||
          fieldValue > field.validation.max
        ) {
          failed = true
          field.error = true
          field.errorMessage = `Value should in between ${field.validation.min} and ${field.validation.max}`
        }
      }
    })
    if (failed) {
      return setformState(newFormState)
    }

    setformState(newFormState)
    let payload: any = {}
    newFormState.forEach((field) => {
      const fieldName = field.label.replaceAll(" ", "_").toLowerCase()
      payload[fieldName] = field.value
    })
    const cleanUpHandler = (loadVal: boolean) => {
      if (!loadVal) {
        setformState([...formFields])
        setLoading(loadVal)
        return
      }
      return setLoading(loadVal)
    }
    createHandler(payload, cleanUpHandler)
  }

  const clearAndClose = () => {
    setformState(JSON.parse(JSON.stringify(formFields)))
    closeHandler()
  }

  const fieldHandler = (e: any, index: number) => {
    e.preventDefault()
    const newState = [...formState]
    newState[index].value = e.target.value
    setformState(newState)
    console.log("newState", newState)
  }
  return (
    <Dialog open={open} onClose={clearAndClose} maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          my: 1,
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold", pl: 2 }}>
          Add New Metric
        </Typography>
        <IconButton sx={{ mr: 1 }} onClick={clearAndClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider />

      <Grid container spacing={1.5} sx={{ px: 2, pb: 2, my: 2 }}>
        {formState.map((ops: formType, index: number) => {
          if (ops.componentType === 1) {
            return (
              <Grid item xs={6} key={ops.label}>
                <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
                  {ops.label} {ops.required && " *"}
                </Typography>
                <TextField
                  error={ops.error}
                  key={ops.label}
                  value={ops.value}
                  onChange={(e) => fieldHandler(e, index)}
                  required={ops?.required}
                  placeholder={ops?.placeHolder}
                  type={ops?.type}
                  fullWidth
                  variant="outlined"
                />
                {ops.error && (
                  <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
                    {ops?.errorMessage}
                  </Typography>
                )}
              </Grid>
            )
          }
          return (
            <Grid item xs={6} key={ops.label}>
              <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
                {ops.label} {ops.required && " *"}
              </Typography>
              <Select
                key={ops.label}
                type={ops?.type}
                error={ops.error}
                onChange={(e) => fieldHandler(e, index)}
                fullWidth
                IconComponent={ExpandMoreIcon}
                value={JSON.stringify(ops.value)}
                renderValue={() => ops.value}
                MenuProps={{
                  sx: {
                    px: 1,
                  },
                }}
                variant="outlined"
              >
                {ops?.options?.map((option) => {
                  return (
                    <MenuItem
                      value={option}
                      sx={{
                        fontWeight: "bold",
                        m: 1,
                        borderRadius: "5px",
                        textAlign: "center",
                      }}
                    >
                      {option}
                    </MenuItem>
                  )
                })}
              </Select>
              {ops.error && (
                <Typography sx={{ fontSize: "9px", color: "red", mt: 0.5 }}>
                  {ops?.errorMessage}
                </Typography>
              )}
            </Grid>
          )
        })}
      </Grid>
      <Box sx={{ display: "flex", flex: 1, columnGap: 1, mb: 2, mx: 2 }}>
        <Button
          variant="outlined"
          fullWidth
          onClick={clearAndClose}
          sx={{ py: 1 }}
        >
          Cancel
        </Button>
        <Button
          endIcon={
            loading && <CircularProgress size="1.5rem" sx={{ color: "#fff" }} />
          }
          variant="contained"
          fullWidth
          onClick={submitHandler}
          sx={{ py: 1 }}
        >
          {loading ? "Creating Metric" : "Create Metric"}
        </Button>
      </Box>
    </Dialog>
  )
}
